













import { Component, Vue } from "vue-property-decorator";
import { Button, Cell } from "vant";
import { env } from "@/env";
@Component({
  components: {
    [Button.name]: Button,
    [Cell.name]: Cell,
  },
})
export default class About extends Vue {
  private url1: string = env.VUE_APP_URL as string;
  private name1: string = env.VUE_APP_NAME as string;
  private env: string = process.env.NODE_ENV as string;
}
